<!-- eslint-disable vue/multi-word-component-names -->

<script setup>
import { ref, onMounted, onBeforeUnmount, defineProps } from 'vue';
const props = defineProps(['url']);

const isShow = ref(false);
function onModalHide() {
    isShow.value = false;
}

function onModalShow() {
    isShow.value = true;
}

onMounted(() => {
    document.addEventListener('show.bs.modal', onModalShow);
    document.addEventListener('hide.bs.modal', onModalHide);
});

onBeforeUnmount(() => {
    document.removeEventListener('show.bs.modal', onModalShow);
    document.removeEventListener('hide.bs.modal', onModalHide);
});

</script>

<template>
    <!-- Modal -->
    <div class="modal fade" id="virtual3DModal" tabindex="-1" aria-labelledby="virtual3DModalLabel" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered modal-xl">
            <div class="modal-content" style="border-radius: 2rem">
                <div class="modal-body p-0">
                    <div v-if="isShow" class="embed-container">
                        <iframe :src="props.url" frameborder="0" allowfullscreen class="embedded-iframe"></iframe>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<style scoped>
.embed-container {
    position: relative;
    width: 100%;
    height: 90vh;
}

.embedded-iframe {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
}
</style>